import { ChangeEvent } from "react";

type FieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  required?: boolean;
  type?: string;
  placeholder?: string;
  autoComplete?: string;
};

/** A labelled input whose error is announced and linked to it. */
const Field = ({
  id,
  label,
  value,
  onChange,
  error,
  required,
  type = "text",
  placeholder,
  autoComplete,
}: FieldProps) => (
  <div className="flex flex-col">
    <label htmlFor={id} className="text-sm font-medium text-gray-800">
      {label}
      {required ? <span aria-hidden="true"> *</span> : <span className="font-normal text-gray-500"> (optional)</span>}
    </label>
    <input
      id={id}
      name={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      autoComplete={autoComplete}
      required={required}
      aria-required={required || undefined}
      aria-invalid={error ? true : undefined}
      aria-describedby={error ? `${id}-error` : undefined}
      className={`mt-2 rounded-lg border px-3 py-2 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-300 ${
        error ? "border-red-400" : "border-orange-200 focus:border-orange-400"
      }`}
    />
    {error && (
      <p id={`${id}-error`} className="mt-1 text-xs text-red-600">
        {error}
      </p>
    )}
  </div>
);

export default Field;
